import { Routes, Route } from "react-router-dom";

import AccountDelete from "../pages/AccountDelete";
import AccountLogin from "../pages/AccountLogin";
import AccountLogout from "../pages/AccountLogout";
import AccountRecover from "../pages/AccountRecover";
import AccountSettings from "../pages/AccountSettings";
import AccountRegister from "../pages/AccountRegister";
import AccountOTC from "../pages/AccountOTC";
import Profile from "../pages/Profile";

export default function Account() {
	return <Routes>
		<Route path="/login" element={<AccountLogin />} />
		<Route path="/logout" element={<AccountLogout />} />
		<Route path="/settings" element={<AccountSettings />} />
		<Route path="/delete" element={<AccountDelete />} />
		<Route path="/register" element={<AccountRegister />} />
		<Route path="/otc" element={<AccountOTC />} />
		<Route path="/recover" element={<AccountRecover />} />
		<Route path="*" element={<Profile />} />
	</Routes>
}